import React, { useEffect, useState } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import InnerBanner from "../components/PagesComponents/InnerBanner";
import ProductSlider from "../components/Common/ProductSlider";
import { showToast } from "../utils/toast";
import { getApi } from "../utils/api/api"; // Reuse the API utility function
import Pagination from "../utils/pagination"; // Reuse pagination component
import DashboardSidebar from "../components/DashboardComponents/DashboardSidebar";

const AdminProductDetail = () => {
  const baseUrl = "https://backend.tokoyarn.com/public/";
  const { id } = useParams();
  const location = useLocation();
  const { language } = useLanguage();
  const product = location.state?.inventory || null;
  const [bids, setBids] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [activeTab, setActiveTab] = useState("product-details");
  const [currentPage, setCurrentPage] = useState(1);
  const [bidsPerPage] = useState(5);

  useEffect(() => {
    if (!product) {
      showToast("error", "Product not found!");
    }
  }, [product]);

  useEffect(() => {
    if (product) {
      fetchBids();
    }
  }, [product]);

  const fetchBids = async () => {
    try {
      const response = await getApi(`admin/products-detail/${id}`);
      const data = response?.data || {};
      if (data.product) {
        setInventoryData(data.product);
      }
      if (data.product.bids) {
        setBids(data.product.bids);
      }
    } catch (error) {
      showToast("error", "Failed to load bids!");
    }
  };

  const formatKey = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastBid = currentPage * bidsPerPage;
  const indexOfFirstBid = indexOfLastBid - bidsPerPage;
  const currentBids = bids.slice(indexOfFirstBid, indexOfLastBid);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(bids.length / bidsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (!product) return <div className="container py-5"><div className="alert alert-danger">Product not found!</div></div>;

  const renderQualityBadge = (grade) => {
    const colors = {
      'A': 'bg-success',
      'B': 'bg-primary',
      'C': 'bg-warning',
      'D': 'bg-danger'
    };
    return (
      <span className={`badge rounded-pill text-white fw-bold px-3 py-2 ${colors[grade] || 'bg-secondary'}`}>
        Grade {grade}
      </span>
    );
  };

  const renderBlendInfo = (spun) => {
    if (!spun || !spun.blend1) return null;
    
    return (
      <div className="blend-info mt-4 pt-3 border-top">
        <h5 className="text-primary mb-3"><i className="bi bi-bezier2 me-2"></i>Blend Composition</h5>
        <div className=" mb-2" style={{ height: '30px', borderRadius: '8px' }}>
          <div className="row">
          <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-primary" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Blend 1</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">{spun.blend1} - ({spun.blend1_percentage}%)</div>
                        </div>
                      </div>
          <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-info" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Blend 2</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">{spun.blend2} - ({spun.blend2_percentage}%)</div>
                        </div>
                      </div>
          </div>            
                                  
          {/*<div 
            className="progress-bar bg-primary fw-bold" 
            role="progressbar" 
            style={{ width: `${spun.blend1_percentage}%` }}
            aria-valuenow={spun.blend1_percentage}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {spun.blend1} ({spun.blend1_percentage}%)
          </div>
          <div 
            className="progress-bar bg-info fw-bold" 
            role="progressbar" 
            style={{ width: `${spun.blend2_percentage}%` }}
            aria-valuenow={spun.blend2_percentage}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {spun.blend2} ({spun.blend2_percentage}%)
          </div>*/}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* <InnerBanner pageTitle="Product Details" /> */}
      <section className="product-detail py-5">
        <div className="container">
          {/* Product Card with Floating Elements */}
          <div className="card shadow-lg h-100 border-0 overflow-hidden" style={{ borderRadius: '20px', position: 'relative' }}>
            {/* Decorative Elements */}
            <div className="position-absolute top-0 end-0 bg-primary" style={{ width: '80px', height: '80px', clipPath: 'polygon(0 0, 100% 0, 100% 100%)' }}></div>
            
            
            <div className="card-body p-lg-5">
            <div className="d-flex justify-content-between align-items-start mb-3">
                    <div>
                      <h1 className="text-primary fw-bold mb-1" style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.1)' }}>{product.type} Yarn</h1>
                      <p className="text-muted fs-5 mb-0">
                       
                        {product.spun?.category} - {product.spun?.sub_category}
                      </p>
                    </div>
                    {renderQualityBadge(product.quality_grade)}
                  </div>
              <div className="row g-5">
                {/* Left Column - Image Slider */}
                <div className="col-lg-6 d-flex align-items-center justify-content-center">
                  <div className="bg-white rounded-3 p-3 shadow-sm border position-relative" style={{ width: '100%', maxWidth: '500px' }}>
                    <div className="position-absolute top-0 start-0 m-3">
                      <span className="badge bg-danger text-white px-3 py-2 fw-bold">HOT</span>
                    </div>
                    {inventoryData.images && inventoryData.images.includes(",") ? (
                      <ProductSlider images={inventoryData.images.split(",")} />
                    ) : inventoryData.images ? (
                      <ProductSlider images={[inventoryData.images]} />
                    ) : (
                      <div className="d-flex flex-column align-items-center justify-content-center text-secondary py-5" style={{ minHeight: '300px' }}>
                        <i className="bi bi-image-fill fs-1"></i>
                        <span className="ms-2 mt-2">No images available</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Right Column - Details */}
                {product.type === 'Spun' ? (
                <div className="col-lg-6">
                  
                  {/*<div className="price-display my-4 p-3 bg-gradient-light rounded-4 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted fw-bold">Current Price:</span>
                      <span className="display-5 text-success fw-bold">
                        {product.spun.price} {product.price_type}
                      </span>
                    </div>
                    
                  </div>*/}

                  <div className="specs-grid mb-4">
                    <h5 className="mb-3 text-dark d-flex align-items-center">
                      <span className="bg-primary text-white p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                        <i className="bi bi-list-check"></i>
                      </span>
                      Key Specifications
                    </h5>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-primary" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">End Use</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">{product.spun?.end_use || 'N/A'}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-info" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Technology</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">{product.spun?.technology || 'N/A'}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-warning" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Ply</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">
                            {product.spun?.ply}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-success" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Application</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">
                            {product.spun?.application}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {renderBlendInfo(product.spun)}
                </div>
              ) : (
                   <div className="col-lg-6">
                  
                 {/* <div className="price-display my-4 p-3 bg-gradient-light rounded-4 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center">
                      <span className="text-muted fw-bold">Current Price:</span>
                      <span className="display-5 text-success fw-bold">
                        {product.filament.price_from} - {product.filament.price_to} {product.price_type}
                      </span>
                    </div>
                   
                  </div>*/}

                  <div className="specs-grid mb-4">
                    <h5 className="mb-3 text-dark d-flex align-items-center">
                      <span className="bg-primary text-white p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                        <i className="bi bi-list-check"></i>
                      </span>
                      Key Specifications
                    </h5>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-primary" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Semi/Full Dull</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">{product.filament?.dull || 'N/A'}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="p-3 bg-white rounded-3 border position-relative h-100" style={{ boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                          <div className="position-absolute top-0 start-0 bg-info" style={{ width: '4px', height: '100%', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }}></div>
                          <small className="text-muted d-block">Texturized</small>
                          <div className="fw-bold fs-6 mt-1 text-dark">{product.filament?.texturized || 'N/A'}</div>
                        </div>
                      </div>
                     
                    </div>
                  </div>
                </div>   
                )}
              </div>
            </div>
          </div>
          
          {/* Tabs Navigation */}
          <ul className="nav nav-pills mt-5 justify-content-center" id="productTabs" role="tablist">
            <li className="nav-item mx-2" role="presentation">
              <button
                className={`nav-link rounded-pill px-4 py-2 fw-bold ${activeTab === "product-details" ? "active bg-primary text-white shadow-sm" : "bg-white text-dark"}`}
                id="product-details-tab"
                data-bs-toggle="tab"
                data-bs-target="#product-details"
                type="button"
                role="tab"
                aria-controls="product-details"
                aria-selected={activeTab === "product-details"}
                onClick={() => setActiveTab("product-details")}
              >
                <i className="bi bi-box-seam me-2"></i>Product Specifications
              </button>
            </li>
            <li className="nav-item mx-2" role="presentation">
              <button
                className={`nav-link rounded-pill px-4 py-2 fw-bold ${activeTab === "bids" ? "active bg-primary text-white shadow-sm" : "bg-white text-dark"}`}
                id="bids-tab"
                data-bs-toggle="tab"
                data-bs-target="#bids"
                type="button"
                role="tab"
                aria-controls="bids"
                aria-selected={activeTab === "bids"}
                onClick={() => setActiveTab("bids")}
              >
                <i className="bi bi-hammer me-2"></i>Bids ({bids.length})
              </button>
            </li>
          </ul>

          {/* Tabs Content */}
          <div className="tab-content mt-4" id="productTabsContent">
            <div
              className={`tab-pane fade ${activeTab === "product-details" ? "show active" : ""}`}
              id="product-details"
              role="tabpanel"
              aria-labelledby="product-details-tab"
            >
              <div className="card shadow-sm border-0 overflow-hidden" style={{ borderRadius: '15px' }}>
                <div className="card-body p-4 p-lg-5">
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="card h-100 border-0 shadow-sm p-3" style={{ borderRadius: '12px' }}>
                        <div className="card-header bg-transparent border-0 d-flex align-items-center">
                          <div className="bg-primary text-white p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                            <i className="bi bi-info-circle"></i>
                          </div>
                          <h4 className="mb-0 text-primary fw-bold">Basic Information</h4>
                        </div>
                        <div className="card-body">
                          <div className="list-group list-group-flush">
                          {product.type === 'Spun' ? (
  [
    { label: "Product Type", value: product.type },
    { label: "Category", value: product.spun.category },
    { label: "Sub Category", value: product.spun.sub_category }
  ].map((item, index) => (
    <div key={index} className="list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom">
      <span className="fw-bold text-muted">{item.label}</span>
      <span className="text-dark">{item.value}</span>
    </div>
  ))
) : (
  [
    { label: "Product Type", value: product.type },
    { label: "Category", value: product.filament.category }
  ].map((item, index) => (
    <div key={index} className="list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom">
      <span className="fw-bold text-muted">{item.label}</span>
      <span className="text-dark">{item.value}</span>
    </div>
  ))
)} 
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-md-6">
                      <div className="card h-100 border-0 shadow-sm p-3" style={{ borderRadius: '12px' }}>
                        <div className="card-header bg-transparent border-0 d-flex align-items-center">
                          <div className="bg-primary text-white p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                            <i className="bi bi-gear-fill"></i>
                          </div>
                          <h4 className="mb-0 text-primary fw-bold">Technical Specifications</h4>
                        </div>
                        <div className="card-body">
                          <div className="list-group list-group-flush">
                                                  {product.type === 'Spun' ? (
  [
    { label: "Count", value: `${product.spun.count_from} - ${product.spun.count_to}` },
    { label: "Avg CSP", value: `${product.spun.avg_csp_from} - ${product.spun.avg_csp_to}` },
    { label: "Yarn Speciality", value: product.spun.yarn_speciality },
    { label: "IPI", value: product.ipi }
  ].map((item, index) => (
    <div key={index} className="list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom">
      <span className="fw-bold text-muted">{item.label}</span>
      <span className="text-dark">{item.value}</span>
    </div>
  ))
) : (
  [
    { label: "Qauntity", value: `${product.filament.quantity_from} - ${product.filament.quantity_to}` },
    { label: "Dennier", value: `${product.filament.dennier_from} - ${product.filament.dennier_to}`   },
    { label: "No. Of Filament", value: `${product.filament.filament_no_from} - ${product.filament.filament_no_to}` },
    { label: "Filament Twist", value: product.filament.filament_twist },
    { label: "Roto Twist Intermingle", value: product.filament.roto_twist_intermingle },
     { label: "IPI", value: product.ipi }
  ].map((item, index) => (
    <div key={index} className="list-group-item d-flex justify-content-between align-items-center px-0 py-3 border-bottom">
      <span className="fw-bold text-muted">{item.label}</span>
      <span className="text-dark">{item.value}</span>
    </div>
  ))
)} 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Certificate Section */}
                  {product.certificate && (
                    <div className="mt-4 pt-4 border-top">
                      <div className="d-flex align-items-center mb-3">
                        <div className="bg-primary text-white p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                          <i className="bi bi-file-earmark-text-fill"></i>
                        </div>
                        <h5 className="mb-0 text-primary fw-bold">Certificates</h5>
                      </div>
                      <div className="d-flex align-items-center">
                        <i className="bi bi-file-earmark-pdf-fill text-danger fs-3 me-3"></i>
                        <div>
                          <p className="mb-1 fw-bold">Quality Certificate</p>
                          <small className="text-muted">PDF Document</small>
                        </div>
                        <a 
                          href={`${baseUrl}${product.certificate}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary rounded-pill px-4 ms-auto"
                        >
                          <i className="bi bi-download me-2"></i>Download
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div
              className={`tab-pane fade ${activeTab === "bids" ? "show active" : ""}`}
              id="bids"
              role="tabpanel"
              aria-labelledby="bids-tab"
            >
              <div className="card shadow-sm border-0 overflow-hidden" style={{ borderRadius: '15px' }}>
                <div className="card-body p-4 p-lg-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="bg-primary text-white p-2 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: '36px', height: '36px' }}>
                      <i className="bi bi-list"></i>
                    </div>
                    <h4 className="mb-0 text-primary fw-bold">Recent Bids</h4>
                  </div>
                  {bids.length > 0 ? (
                    <>
                      <div className="table-responsive">
                        <table className="table table-hover align-middle">
                          <thead className="table-light">
                            <tr>
                              <th>Bid Amount</th>
                              <th>Bidder</th>
                              <th>Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentBids.map((bid, index) => (
                              <tr key={index}>
                                <td className="fw-bold text-success">{bid.bid_amount} {bid.bid_type}</td>
                                <td>{bid.bidder_name || 'Anonymous'}</td>
                                <td>{new Date(bid.created_at).toLocaleDateString()}</td>
                                <td>
                                  <span className="badge bg-info text-white">Active</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-center mt-4">
                        <Pagination
                          currentPage={currentPage}
                          totalPages={Math.ceil(bids.length / bidsPerPage)}
                          onPageChange={handlePageChange}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-5">
                      <div className="bg-light rounded-circle p-4 d-inline-block mb-3">
                        <i className="bi bi-hammer fs-1 text-muted"></i>
                      </div>
                      <h5 className="text-muted">No bids have been placed yet</h5>
                      {/*<p className="text-muted">Be the first to place a bid on this product</p>
                      <button className="btn btn-primary rounded-pill px-4 mt-3">
                        Place Your Bid
                      </button>*/}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdminProductDetail;